export const ROUTE_SIGN_IN = {
  path: '/sing-in',
  name: 'sign-in',
};

export const ROUTE_HOME = {
  path: '/',
  name: 'home',
};

export const ROUTE_RECEBIMENTO = {
  path: '/recebimento',
  name: 'recebimento',
};

export const ROUTE_RECEBIMENTO_RESUMO = {
  path: '/recebimento/resumo',
  name: 'recebimento.resumo',
};

export const ROUTE_PESAGEM = {
  path: '/pesagem',
  name: 'pesagem',
};

export const ROUTE_FILA = {
  path: '/fila',
  name: 'fila',
};
